"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactSortableHoc = require("react-sortable-hoc");

var _animateCssGrid = require("animate-css-grid");

var _reactDom = _interopRequireDefault(require("react-dom"));

var _Clip = _interopRequireDefault(require("../../Clip"));

require("../styles/_clips.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var EMPTY_CLIP = {
  clipId: 'empty',
  duration: 0,
  isImage: false,
  isEmpty: true,
  clipStartTime: 0,
  startTime: 0,
  originalDuration: 0,
  assetId: ''
};
var SortableGrid = (0, _reactSortableHoc.SortableContainer)(function (_ref) {
  var children = _ref.children,
      setRef = _ref.setRef;
  return (/*#__PURE__*/_react.default.createElement("div", {
      ref: setRef,
      className: (0, _classnames.default)('clips__droppable', 'clips__droppable--grid')
    }, children)
  );
});
var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref2) {
  var children = _ref2.children;
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "clips__droppable--list"
    }, children)
  );
});

var Clips = /*#__PURE__*/function (_Component) {
  _inherits(Clips, _Component);

  var _super = _createSuper(Clips);

  function Clips() {
    var _this;

    _classCallCheck(this, Clips);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "setGridDragAnimation", function (el) {
      if (!el) {
        return;
      } // The animation library requires a DOM node
      // eslint-disable-next-line react/no-find-dom-node


      _this._gridRef = _reactDom.default.findDOMNode(el);
    });

    _defineProperty(_assertThisInitialized(_this), "getClipsWithEmpty", function () {
      var _this$props = _this.props,
          clips = _this$props.clips,
          clipsView = _this$props.clipsView,
          emptyClipIndex = _this$props.emptyClipIndex,
          isOver = _this$props.isOver;

      if (clipsView === 'LIST' || !isOver || !clips.length || emptyClipIndex === void 0) {
        return clips;
      }

      var newClips = _toConsumableArray(clips);

      newClips.splice(emptyClipIndex, 0, EMPTY_CLIP);
      return newClips;
    });

    return _this;
  }

  _createClass(Clips, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          isOver = _this$props2.isOver,
          clips = _this$props2.clips,
          resetEmptyClipIndex = _this$props2.resetEmptyClipIndex;
      var isNoLongerOver = !isOver && prevProps.isOver;

      if (isNoLongerOver) {
        // Timeout here to account for clip drop BEFORE we reset (!isOver will trigger before drop)
        setTimeout(resetEmptyClipIndex, 100);
      }

      if (isNoLongerOver && prevProps.clips.length >= 1 && this._unwrapGrid) {
        this._unwrapGrid();
      }

      if (isOver && !prevProps.isOver && clips.length >= 1 && this._gridRef) {
        this._unwrapGrid = (0, _animateCssGrid.wrapGrid)(this._gridRef).unwrapGrid;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          clipsView = _this$props3.clipsView,
          onSortEnd = _this$props3.onSortEnd,
          onSortStart = _this$props3.onSortStart,
          connectDropTarget = _this$props3.connectDropTarget,
          isOver = _this$props3.isOver,
          clips = _this$props3.clips,
          selectedClipId = _this$props3.selectedClipId,
          onSelectClip = _this$props3.onSelectClip,
          onChangeClipIndex = _this$props3.onChangeClipIndex,
          onDragOver = _this$props3.onDragOver,
          emptyClipIndex = _this$props3.emptyClipIndex,
          onRemoveClip = _this$props3.onRemoveClip,
          canUpdateVideo = _this$props3.canUpdateVideo,
          comments = _this$props3.comments,
          deleteComment = _this$props3.deleteComment;
      var List = clipsView === 'GRID' ? SortableGrid : SortableList;

      var emptyClip = /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)({
          'clips__droppable--list__empty-clip': clipsView === 'LIST',
          'clips__droppable--grid__empty-clip': clipsView === 'GRID'
        }),
        key: "empty",
        style: {
          transform: clipsView === 'LIST' ? "translateY(calc(".concat(emptyClipIndex * 100, "% + ").concat(20 * emptyClipIndex, "px))") : void 0
        }
      });

      return connectDropTarget( /*#__PURE__*/_react.default.createElement("div", {
        className: "clips"
      }, !clips.length ? /*#__PURE__*/_react.default.createElement("p", {
        className: "clips__empty-text"
      }, "Drag some video assets here to get started") : null, /*#__PURE__*/_react.default.createElement(List, {
        onSortEnd: onSortEnd,
        onSortStart: onSortStart,
        axis: clipsView === 'GRID' ? 'xy' : 'y',
        pressDelay: 150,
        setRef: this.setGridDragAnimation,
        disableKeyboardInteraction: true
      }, clipsView === 'LIST' ? emptyClip : null, this.getClipsWithEmpty().map(function (clip, index) {
        return clip.isEmpty ? emptyClip : /*#__PURE__*/_react.default.createElement(_Clip.default, {
          key: clip.clipId,
          clip: clip,
          index: index,
          clipsView: clipsView,
          clipsLength: clips.length,
          selectedClipId: selectedClipId,
          onSelectClip: onSelectClip,
          onChangeClipIndex: onChangeClipIndex,
          onDragOver: isOver ? onDragOver(clip.clipId) : void 0,
          isOver: isOver,
          position: index >= emptyClipIndex ? index + 1 : index,
          onRemoveClip: onRemoveClip,
          assetId: clip.assetId,
          canUpdateVideo: canUpdateVideo,
          comments: comments,
          deleteComment: deleteComment
        });
      }))));
    }
  }]);

  return Clips;
}(_react.Component);

exports.default = Clips;